module.exports = require("./ar-BH");